<template>
  <div>
    <div
      v-show="question_sequence > -1 && !showtext && !alldone"
      class="col-lg-8 col-md-10 col-sm-12 col-xs-12 mx-auto mt-4"
    >
      <b-progress
        variant="secondary"
        height="2rem"
        :max="examquestions.length"
        align-v="center"
      >
        <b-progress-bar align-v="center" :value="question_sequence" />
        <div
          align-v="center"
          style="z-index: 1;position: absolute;left:16px;border"
          class="col-12 px-4 pt-3 text-center"
        >
          <span class="text-black">
            {{ question_sequence + 1 }} {{ text_38 }} {{ examquestions.length }}
          </span>
        </div>
      </b-progress>
    </div>
    {{ /* Question section */ }}
    <div
      v-if="showquestionsection && !loading && !alldone"
      class="col-lg-6 col-md-8 col-sm-10 col-xs-12 mx-auto gdqquestion"
    >
      <h3 class="my-4 py-4">
        <span v-show="question_sequence > -1"
          >{{ question_sequence + 1 }}.
        </span>
        {{ examquestions[question_sequence].question_text }}
      </h3>
      {{ /* Question type 1 - Vertical Radio Buttons */ }}
      <div
        v-show="examquestions[question_sequence].question_type_id == 1"
        class="ml-0 pl-0"
      >
        <b-button-group
          vertical
          class="btn-group btn-group-vertical btn-group-toggle col-lg-10 col-md-10 col-sm-12 col-xs-12 ml-0 pl-0"
        >
          <label
            v-for="option in examquestions[question_sequence].options"
            :id="'o' + option.id"
            :key="option.id"
            class="btn btn-questionnaire my-2 text-left ml-0"
            :class="
              (examanswers[question_sequence] != null &&
                examanswers[question_sequence] ===
                  option.questionoption_value) ||
              currentoption === option.id
                ? 'btn-primary'
                : 'btn-outline-primary'
            "
            :disabled="settinganswer"
            @click.prevent="
              currentoption = option.id;
              setanswer(
                question_sequence,
                option.questionoption_value,
                examquestions[question_sequence].question_id
              );
            "
          >
            <span
              v-if="
                examanswers[question_sequence] != null &&
                examanswers[question_sequence] === option.questionoption_value
              "
              class="mr-2"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 512 512"
                focusable="false"
                class="white fa-icon"
              >
                <path
                  d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"
                />
              </svg>
            </span>
            <span
              v-if="
                examanswers[question_sequence] != null &&
                examanswers[question_sequence] !== option.questionoption_value
              "
              class="w-10 mr-2"
            >
              &nbsp;&nbsp;&nbsp;
            </span>
            <input
              type="radio"
              autocomplete="off"
              class="text-left"
              :checked="
                examanswers[question_sequence] != null &&
                examanswers[question_sequence] === option.questionoption_value
              "
            />{{ option.questionoption_text }}
          </label>
        </b-button-group>
      </div>
      {{ /* Question type 2 - Textbox */ }}
      <div
        v-show="examquestions[question_sequence].question_type_id == 2"
        class="row px-3"
      >
        <b-input-group>
          <b-form-input
            v-if="examquestions[question_sequence].only_digits == 0"
            v-model="examanswers[question_sequence]"
            class="col-12"
            @keyup.enter.native="
              examanswers[question_sequence] != '' ? nextpage(300) : false
            "
          />
          <b-form-input
            v-if="examquestions[question_sequence].only_digits == 1"
            v-model="examanswers[question_sequence]"
            class="col-12"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            @keyup.enter.native="
              examanswers[question_sequence] != '' ? nextpage(300) : false
            "
          />
          <b-input-group-append>
            <b-button
              variant="primary"
              :disabled="
                !examanswers[question_sequence] ||
                examanswers[question_sequence] == '' ||
                settinganswer
              "
              class="btn-small btn-questionnaire pb-1 pt-1"
              @click.prevent="nextpage(300)"
            >
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 512 512"
                  focusable="false"
                  class="white fa-icon"
                >
                  <path
                    d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"
                  />
                </svg>
              </span>
              OK
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      {{ /* Question type 3 - Textarea */ }}
      <div v-show="examquestions[question_sequence].question_type_id == 3">
        <b-form-textarea
          v-model="examanswers[question_sequence]"
          :maxlength="
            examquestions[question_sequence].text_maxlength != 0
              ? examquestions[question_sequence].text_maxlength
              : 100
          "
          class="col-12"
        />
        <div class="col-12 text-right">
          {{ text_27 }}:
          {{
            examquestions[question_sequence].text_maxlength != 0
              ? examquestions[question_sequence].text_maxlength
              : 100 -
                (examanswers[question_sequence]
                  ? examanswers[question_sequence].length
                  : 0)
          }}
        </div>
      </div>
      {{ /* Question type 4 - Horizontal radio buttons */ }}
      <div
        v-show="examquestions[question_sequence].question_type_id == 4"
        class="text-center"
      >
        <b-button-group
          horizontal
          class="btn-group btn-group-horizontal btn-group-toggle col text-center"
        >
          <label
            v-for="option in examquestions[question_sequence].options"
            :id="'o' + option.id"
            :key="option.id"
            class="btn btn-questionnaire btn-questionnaire-horizontal btn-iphone text-center py-4"
            :class="
              (examanswers[question_sequence] != null &&
                examanswers[question_sequence] ===
                  option.questionoption_value) ||
              currentoption === option.id
                ? 'btn-primary'
                : 'btn-outline-primary'
            "
            :disabled="settinganswer"
            @click.prevent="
              currentoption = option.id;
              setanswer(
                question_sequence,
                option.questionoption_value,
                examquestions[question_sequence].question_id
              );
            "
          >
            <span
              v-if="
                examanswers[question_sequence] &&
                examanswers[question_sequence] == option.questionoption_value
              "
              class="mr-2"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 512 512"
                focusable="false"
                class="white fa-icon"
              >
                <path
                  d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"
                />
              </svg>
            </span>
            <input type="radio" class="text-center" />{{
              option.questionoption_text
            }}
          </label>
        </b-button-group>
      </div>
    </div>
    <div
      v-if="
        question_sequence > -1 &&
        question_sequence < examquestions.length &&
        showtext
      "
      class="col-lg-8 col-md-10 col-sm-12 col-xs-12 mx-auto gdqquestion"
    >
      <div v-show="examquestions[question_sequence].question_section == 'Q'">
        <span class="h5" v-html="text_23" />
      </div>
    </div>
    <div class="my-4 py-4">&nbsp;</div>
    <div
      v-show="alldone"
      class="col-lg-8 col-md-10 col-sm-12 col-xs-12 h4 py-4 my-4 mx-auto text-center"
    >
      <h4>Exam done</h4>
      <b-button @click="course_set"> Back to overview </b-button>
    </div>
    <div
      v-show="!alldone"
      class="row col-lg-8 col-md-8 col-sm-12 col-xs-12 mx-auto py-4 my-4"
    >
      <div class="col-6 pl-0">
        <b-button
          v-show="question_sequence > 0"
          class="align-left"
          variant="secondary"
          @click.prevent="prevpage"
        >
          &lt; {{ text_1 }}
        </b-button>
        <b-button
          v-show="question_sequence < 1"
          class="align-left"
          variant="secondary"
          @click.prevent="course_set"
        >
          &lt; {{ text_1 }}
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import ExamNotes from './ExamNotes.vue'
import { config } from '@/../config'
const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds))
}
export default {
  name: 'LearningExam',
  components: {
    ExamNotes
  },
  props: {
    examId: {
      type: String,
      required: true // Set to false if the prop is optional
    },
    courseId: {
      type: String,
      required: true // Set to false if the prop is optional
    },
    moduleId: {
      type: String,
      required: true // Set to false if the prop is optional
    }
  },
  data () {
    return {
      consultant_id: this.$store.state.user_id,
      course_id: 0,
      module_id: 0,
      exam_id: 0,
      learningcourse: null,
      learningexam: null,
      examquestions: [],
      examanswers: [],
      settinganswer: false,
      loading: true,
      question_sequence: 0,
      showquestionsection: true,
      text_1: '',
      text_2: '',
      text_23: '',
      text_27: '',
      text_37: '',
      text_38: '',
      language_id: 38,
      currentoption: 0,
      showtext: false,
      alldone: false
    }
  },
  created () {
    this.exam_id = this.examId
    this.course_id = this.courseId
    this.module_id = this.moduleId
    this.init()
  },
  methods: {
    init () {
      this.questionnairetexts_get()
      this.exam_get()
    },
    exam_get () {
      this.$store
        .dispatch('record_read', {
          table_name: 'g_elearning_exams',
          id: this.exam_id
        })
        .then((resp) => {
          this.learningexam = resp.data
          const filter = {
            exam_id: {
              operator: '=',
              value: this.learningexam.id
            }
          }
          this.$store
            .dispatch('records_readall', {
              table_name: 'g_elearning_exams_questions',
              filter,
              orderby: 'exam_question_number'
            })
            .then((resp) => {
              let examquestions = resp.data.result
              for (let i = 0; i < examquestions.length; i++) {
                this.$store
                  .dispatch('record_read', {
                    table_name: 'g_elearning_questions',
                    id: examquestions[i].question_id
                  })
                  .then((resp) => {
                    const question = resp.data
                    examquestions[i]['question_text'] = question.question_text
                    examquestions[i]['question_type_id'] =
                      question.question_questiontype_id
                    examquestions[i]['only_digits'] = question.only_digits
                    examquestions[i]['text_maxlength'] =
                      question.text_maxlength
                  })
                const filter = {
                  question_id: {
                    operator: '=',
                    value: examquestions[i].question_id
                  }
                }
                this.$store
                  .dispatch('records_readall', {
                    table_name: 'g_elearning_question_options',
                    filter
                  })
                  .then((resp) => {
                    examquestions[i]['options'] = resp.data.result

                    this.examquestions = examquestions
                    // this.$nextTick(() => {

                    // });
                  })
                  .then(() => {
                    console.log('Loaded exam and questions')
                    this.loading = false
                  })
              }
            })
        })
    },
    questionnairetexts_get () {
      this.$store
        .dispatch('questionnairetexts_fetch', { language_id: this.language_id })
        .then((resp) => {
          // var maillink = '<a href="mailto:'+this.consultant_email+'">'+this.consultant_name+'</a>';
          this.text_1 = resp.data[1] ? resp.data[1] : 'Back'
          this.text_2 = resp.data[2] ? resp.data[2] : 'Next'
          // Privacy policy
          const link =
            '<a href="' + config.links.privacyPolicy + '" target="_new">'
          this.text_23 = resp.data[23]
            ? resp.data[23]
            : 'Please read each statement below. Choose the number that most accurately describes this group at the present time. Use the following key to respond to each statement.<br><br>1 = never true of this group<br>2 = rarely true of this group<br>3 = sometimes true of this group<br>4 = frequently true of this group<br>5 = always true of this group<br><br>Sample question: This group spends considerable time working on important issues.<br><br>If this is never true of this group, mark the number “1” in the box provided for this sample item. If working on important issues is a rare occurrence, mark the number “2” in the box. If working on important issues occurs to some extent, mark the number “3” in the box. If work of this type is frequent, mark the number “4” in the box. If the group, in your opinion, is always working on important issues, mark the number “5” in the box.<br><br>Using the same procedure respond to each of the following statements.'
          this.text_27 = resp.data[27] ? resp.data[27] : 'Characters left'
          this.text_37 = resp.data[37]
            ? resp.data[37]
            : '* = mandatory question'
          this.text_38 = resp.data[38] ? resp.data[38] : 'of'
        })
    },
    async setanswer (id, answer) {
      if (this.settinganswer) {
        return false
      }
      this.settinganswer = true
      this.examanswers[id] = answer
      await this.nextpage(300).then(() => {
        this.settinganswer = false
      })
    },
    course_set () {
      this.$router.push('/elearningcourse/' + this.course_id)
    },
    nextpage: async function (millisecs) {
      await sleep(millisecs).then(() => {
        var _this = this
        if (this.question_sequence == this.examquestions.length - 1) {
          this.alldone = true
          this.showquestionsection = false
          this.saveanswers(this.examquestions, this.examanswers)
          return false
        }
        _this.question_sequence++
      })
    },
    prevpage: async function (millisecs) {
      await sleep(millisecs).then(() => {
        var _this = this
        if (this.question_sequence == 0) {
          return false
        }

        _this.question_sequence--
      })
    },
    saveanswers: function (questions, answers) {
      this.saving = true
      var saveanswers = []
      var question_sequence = 0
      let _this = this
      questions.forEach(function (item, index) {
        var newanswer = {
          consultant_id: _this.consultant_id,
          course_id: _this.course_id,
          exam_id: _this.exam_id,
          question_id: item.question_id,
          examquestion_id: item.id,
          answer: answers[question_sequence]
        }
        saveanswers.push(newanswer)
        question_sequence++
      })
      var data = {
        consultant_id: this.consultant_id,
        exam_id: this.exam_id,
        course_id: this.course_id,
        answers: saveanswers
      }
      return this.$store
        .dispatch('elearning_allanswers_save', data)
        .then((resp) => {
          this.checkexam()
          return resp
        })
    },
    checkexam: function () {
      this.$store
        .dispatch('elearning_exam_check', {
          consultant_id: this.consultant_id,
          module_id: this.module_id,
          exam_id: this.exam_id
        })
        .then((resp) => {
          if (resp.data.result) {
            if (resp.data.number_questions == resp.data.number_correct) {
            }
          }
        })
    }
  }
}
</script>
<style scoped></style>
